export default __webpack_public_path__ + "static/media/AdobeStock_453518764.8dcee15c.jpeg";